<template>
    <fullscreen class="fullscreen" ref="fullscreen" @change="fullscreenChange">
        <button class="button-adjust" type="button" @click="toggle"><i :class="buttonClass"></i></button>
        <div class="pagecenter">
            <!--<button class="button-adjust" type="button" @click="toggle"><i :class="fa fa-expand"></i></button>-->
            <div class="pagecenterdetails">
                <div class="logo">
                    <img src="static/images/logo111.png" alt="Velocity Vehicle Group">
                    <!-- The modal -->
                    <!--<b-modal ref="my-modal" id="my-modal" hide-footer ok-only ok-variant="secondary" ok-title="Ok">
                        <div class="form-group">
                            <label for="selectedLocation">Select Location<span class="text-danger">*</span></label>
                            <v-select v-model="selectedLocation" name="location" placeholder="Type Location Here"
                                      label="location_name"
                                      id="selectedLocation"
                                      @input="onchangeLocation()"
                                      :options="locationOptions" class="" >
                            </v-select>
                            <font class="text-danger">{{locationError}}</font>
                        </div>
                        <br>
                        <b-button class="mt-3 selectbtn" variant="outline-success" block @click="hideModal">Select</b-button>
                    </b-modal>-->
                </div>
                <!--<div class="selectlocation">
                    <b-button v-if="locationId == ''" class="btn btn-primary selectbtn" v-b-modal.my-modal>Select Location</b-button>
                    <b-button v-if="locationId != ''" class="btn btn-primary selectbtn" v-b-modal.my-modal>{{locationName}}</b-button>
                </div>-->
                <div class="number">
                    <div v-show="!isClosed" class="numberdetails">
                        <!--<strong>Station No : 23</strong>-->
                        <!--<strong>{{locationName}}</strong>-->
                        <span v-if="isWillCall">WILL CALL</span>
                        <span v-if="!isWillCall">Front Counter</span>
                        <p>{{closedTicketNumber}}</p>
                        <span>NOW SERVING</span>
                    </div>


                    <div v-show="isClosed" class="numberdetails">
                        <img src="static/images/closed.png" alt="Velocity Vehicle Group">
                    </div>

                </div>

            </div>
        </div>
    </fullscreen>

</template>

<script>
    import Vue from 'vue';
    import {HTTP} from '../http-common';
    import vSelect from 'vue-select';
    import {commonMixins} from '../mixins/commonMixins';
    import fullscreen from 'vue-fullscreen';
    Vue.use(fullscreen);
    export default {
        name: "RecentClosed",
        mixins: [commonMixins],
        components: {
            'v-select': vSelect,
        },
        data() {
            return {
                buttonClass : "fa fa-expand",
                fullscreen: false,
                selectedLocation:'',
                locationOptions:[],
                locationName : '',
                closedTicketNumber : '',
                locationId : '',
                locationData: {
                    location_id: 0,
                },
                isWillCall: false,
                // Frontend Error
                locationError : '',
                isClosed : false,
                retryInterval: 1000,
                retryFactor: 2,
                inError: false,
            }
        },

        mounted:function(){
            let self = this;
            let userObj = JSON.parse(localStorage.getItem("user_obj"));
            if (userObj != null) {
                let locationId = JSON.parse(localStorage.getItem("user_obj")).location_id;
                self.locationId = locationId;
            }

            $("#closed_time").hide();

            self.locationId = localStorage.getItem("tv_location_id");
            if(self.locationId) {
                self.getLocationDetails(self.locationId);
                self.loadLocations();
                //self.initEventSource();
                self.initEventSource();
            } else {
                alert("Session Timeout!, please login again!");
                self.$router.push("/login");
            }

        },
        beforeDestroy() {
            if (this.echoChannel) {
                window.Echo.leave(`recent-closed.${this.locationId}`);
            }
        },

        methods: {
            
            toggle () {
                this.$fullscreen.toggle(this.$el.querySelector('.pagecenter'), {
                    wrap: true,
                    callback: this.fullscreenChange
                })
            },
            fullscreenChange (fullscreen) {
                this.fullscreen = fullscreen;
                if (fullscreen == true) {
                    this.buttonClass = "fa fa-compress";
                } else {
                    this.buttonClass = "fa fa-expand";
                }
            },
            getLocationDetails(locationId) {
                let self= this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                };

                self.locationData.location_id=locationId;

                if( self.locationData.location_id != '')
                {
                    var locationData=self.locationData;
                    HTTP.post('location/byLocationId',locationData,config)
                        .then(function (response) {
                            console.log(response);
                            if (response.data.code == 200) {
                                self.locationName = response.data.content.name;
                                if(self.locationName.indexOf("Will Call") != -1) {
                                    self.isWillCall = true;
                                }
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                              self.error = err.response.data.message;
                            }
                        })
                }
            },
            hideModal() {
                let self = this;
                if (self.checkForm()) {
                    self.locationId = self.selectedLocation.location_id;
                    self.locationName = self.selectedLocation.location_name;
                    this.$refs['my-modal'].hide();
                }
            },
            initEventSource: function () {
                let self = this;

                if (self.locationId == null) {
                    return;
                }

                // Unsubscribe before subscribing again
                if (self.echoChannel) {
                    window.Echo.leave(`recent-closed.${self.locationId}`);
                }

                self.echoChannel = window.Echo.channel(`recent-closed.${self.locationId}`);

                self.echoChannel.listen('.ticket.closed', function (event) {
                    self.inError = false;
                    if (event.status === 'closed') {
                        self.isClosed = true;
                    } else if (event.status === 'NA') {
                        self.closedTicketNumber = '-';
                        self.isClosed = false;
                    } else {
                        self.closedTicketNumber = event.ticket_no || event.status;
                        self.isClosed = false;
                    }
                });

                // Optional: handle connection errors (Echo uses socket.io which handles reconnections)
            },

            onchangeLocation : function () {
                let self = this;
                self.locationError = '';
            },
            changeLocation : function () {
                $('#recentClosedTicket').modal('show');
            },
            checkForm: function () {
                let self = this;
                var checked = true;
                if (!self.selectedLocation) {
                    self.locationError = "Location Required";
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },
            updateLocation : function () {
                let self = this;
                if (self.checkForm()) {
                    $('#recentClosedTicket').modal('hide');
                    self.locationName = self.selectedLocation.location_name;
                }
            }
        }
    }
</script>

<style>
    /*fonts*/
    @font-face {
        font-family: 'SanFranciscoDisplayRegular';
        src: url("../../static/fonts/SanFranciscoDisplayRegular.eot");
        src: url("../../static/fonts/SanFranciscoDisplayRegular.eot?#iefix") format("embedded-opentype"),
        url("../../static/fonts/SanFranciscoDisplayRegular.woff2") format("woff2"),
        url("../../static/fonts/SanFranciscoDisplayRegular.woff") format("woff"),
        url("../../static/fonts/SanFranciscoDisplayRegular.ttf") format("truetype");
        font-weight: normal;
        font-style: normal;
    }
    @font-face {
        font-family: 'SanFranciscoDisplayBold';
        src: url("../../static/fonts/SanFranciscoDisplayBold.eot");
        src: url("../../static/fonts/SanFranciscoDisplayBold.eot?#iefix") format("embedded-opentype"), url("../../static/fonts/SanFranciscoDisplayBold.woff2") format("woff2"), url("../../static/fonts/SanFranciscoDisplayBold.woff") format("woff"), url("../../static/fonts/SanFranciscoDisplayBold.ttf") format("truetype");
        font-weight: bold;
        font-style: normal;
    }
    @font-face {
        font-family: 'SanFranciscoDisplayThin';
        src: url("../../static/fonts/SanFranciscoDisplayThin.eot");
        src: url("../../static/fonts/SanFranciscoDisplayThin.eot") format("embedded-opentype"), url("../../static/fonts/SanFranciscoDisplayThin.woff2") format("woff2"), url("../../static/fonts/SanFranciscoDisplayThin.woff") format("woff"), url("../../static/fonts/SanFranciscoDisplayThin.ttf") format("truetype"), url("../../static/fonts/SanFranciscoDisplayThin.svg#SanFranciscoDisplayThin") format("svg");
    }
    /*fonts*/

    body {
        float: left;
        width: 100%;
        padding:0;
        background: #f5f5f5;
        margin: 0;
        text-align: center;


    }






    .number {
        float: none;
        width: 90%;
        background: #fff;
        padding: 40px;
        -webkit-box-shadow: 0 0 7px 1px #ddd;
        box-shadow: 0 0 7px 1px #ddd;
        /*border: 1px solid #d3dee3;*/
        border-radius: 5px;
        text-align: center;
        font-weight: 300;
        margin-top: 50px;
        font-weight: bold;
        display: table;
        margin: 30px auto auto auto;
        text-align: center;
        height: 65vh;
        line-height: normal;
    }
    .pagecenter{ width: 100%; display: table; text-align: center; padding: 0;  -ms-transform: translateX(-50%) translateY(-50%);
        -webkit-transform: translate(-50%,-50%);
        transform: translate(-50%,-50%); position:fixed; top:50%;
        left:50%; height: 100vh;}
    .numberdetails , .pagecenterdetails{
        display: table-cell;
        vertical-align: middle;
    }
    .number strong {
        font-size: 70px;
        line-height: normal;
        float: left;
        width: 100%;
        line-height: 70px;
        font-family: 'SanFranciscoDisplayThin';
    }
    .number span {
        font-size: 52px;
        float: left;
        width: 100%;
        text-align: center;
        /*font-family: 'SanFranciscoDisplayThin';*/
    }
    .number p {
        float: left;
        width: 100%;
        font-size: 400px;
        line-height: 370px;
        margin: 0;
        font-family: 'SanFranciscoDisplayBold';
        color: #0c1d43;
    }
    .fullscreen {
        background: whitesmoke;
    }
    .button-adjust {
        position: absolute;
        right: 20px;
        top: 20px;
        z-index: 999;
        background: #0c1d43;
        border: 1px solid #0c1d43;
        color: #fff;
        border-radius: 5px;
        width: 35px;
        height: 35px;
    }
</style>



// WEBPACK FOOTER //
// src/components/RecentClosedTickets.vue